import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
//Components
import MainCard from '../../components/MainCard/MainCard';
import ModalCustomized from '../../components/Modal/Modal';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';
//Api
import MTR_api from '../../api/MTR_api';
//Helpers
import { getSessionCookie } from '../../helpers/cookies';
import mascaras from '../../helpers/mascaras';
import { showMessage } from '../../helpers/message';

//Context
import { useAuth } from '../../context/auth';

export default function FichaMTR({ btnVoltar, mtrParam = {}, filtros, agenda }) {
    const { setupVariavel } = useAuth();

    //Estado que faz o controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Utilizado para navegação
    const navigate = useNavigate();
    //Estado de controle da mtr
    const [mtrState, setMtrState] = useState(mtrParam);
    //Estado que guarda os dados da mtr
    const [mtr, setMtr] = useState(mtrParam);
    //Abre os campos de filtros
    const [openModal, setOpenModal] = useState(false);
    //Faz a troca da visualização dos campos de filtros
    const toggleModal = () => setOpenModal(!openModal);
    //Usuario que esta logado
    const usuario = getSessionCookie();
    //Botão de editar
    const EditarButton = () => {
        return (
            <Button className='mb-3' color='warning text-light' onClick={toggleModal}>
                <FontAwesomeIcon icon={faEdit} /> Editar
            </Button>
        )
    }
    const onChangeMTR = (e) => {
        const { name, value } = e.target;
        setMtrState({
            ...mtrState,
            [name]: value
        })
    }
    const loadMtr = (filtros) => {
        setLoading(true);
        MTR_api.GetList(filtros).then(response => {
            Object.keys(response.data[0]).map(key => {
                if ((response.data[0][key].toString().indexOf(".") != -1 && typeof response.data[0][key] == "number") || key == "volumeColetado" || key == "volume") {
                    response.data[0][key] = response.data[0][key].toFixed(2);
                    response.data[0][key] = response.data[0][key].toString();
                    response.data[0][key] = response.data[0][key].replace('.', ',');
                }
            });
            setMtr(response.data[0]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => {
            setLoading(false);
        })
    }
    const atualizaMTR = () => {
        setLoading(true);
        const _mtr = { tbOrdemColetaColetado_Id: mtrState.codigoMTR, volume: parseFloat(mtrState.volumeColetado.replace(",", ".")) };
        MTR_api.AtualizaMtr(_mtr).then(response => {
            mtr.volumeColetado = _mtr.volume;
            showMessage("Sucesso", "Volume atualizado com sucesso", "success", () => {
                toggleModal();
                loadMtr({ idMTR: mtr.codigoMTR, status: mtr.status });
            });
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => {
            setLoading(false);
        });
    }
    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={() => {
            navigate(`../../empty/relatorio/relatorio${setupVariavel?.siglaDocumentoColeta.toUpperCase()}`,
                {
                    state: {
                        idMTR: mtr.codigoMTR,
                        statusMTR: mtr.status,
                        pdf: true,
                        mtr: mtr,
                        filtros: filtros,
                        rotaVoltar: agenda ? null : `../../admin/pesquisa-${setupVariavel?.siglaDocumentoColeta.toLowerCase()}`
                    }
                }
            );
        }
        }
            BtnAction1InTop={usuario.acesso.sigla === "GS" ? EditarButton : null} >
            {loading && <Loading />}
            <ModalCustomized 
            isOpen={openModal} 
            toggle={toggleModal} 
            title={<><FontAwesomeIcon 
            icon={faEdit} /> Editar {setupVariavel?.siglaDocumentoColeta}</>}
             btnClose btnAction={<><FontAwesomeIcon 
             icon={faEdit} /> Editar</>} 
             btnActionColor="warning text-light" 
             onClickBtnAction={atualizaMTR}
             >
                <Row>
                    <Col md="12" lg="12">
                        <TextField mask={mascaras.floatMask} label={"Volume Coletado(Kg)"} name={"volumeColetado"} value={mtrState.volumeColetado} onChange={onChangeMTR} />
                    </Col>
                </Row>
            </ModalCustomized>
            <div style={{ color: "#666" }}>
                <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Detalhes da {setupVariavel?.siglaDocumentoColeta}</h5>
                <Row>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Número da {setupVariavel?.siglaDocumentoColeta}: </span>{mtr.codigoMTR}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Gerador: </span>{mtr.gerador}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Data da programação: </span>{mtr.programacao}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Transportador: </span>{mtr.transportador}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Destino: </span>{mtr.destino}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">TAG: </span>{mtr.tag}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Modalidade: </span>{mtr.modalidade}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Status: </span>{mtr.status}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Volume coletado({mtr?.unidade?.toUpperCase()}): </span> {mtr?.volumeColetado} {mtr?.unidade?.toUpperCase()}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Data coletada: </span>{mtr.dataColetada}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Data entrada: </span>{mtr.dataEntrada}</p>
                    </Col>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Peso descartado: </span>{mtr?.volume} Kg</p>
                    </Col>
                </Row>
                <Row>
                    <Col md={"12"} lg="4">
                        <p><span className="fw-bold">Data de descarte: </span>{mtr.dataSaida}</p>
                    </Col>
                </Row>
            </div>
        </MainCard >
    );

}